import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ReconciliationService } from '../../core/services/reconciliation.service';
import { MoneyDto, ReconRunResponse } from '../../core/models/reconciliation';

@Component({
  selector: 'app-reconciliation-run-detail',
  standalone: true,
  imports: [CommonModule, RouterModule, DatePipe],
  templateUrl: './reconciliation-run-detail.component.html',
  styleUrls: ['./reconciliation-run-detail.component.css'],
})
export class ReconciliationRunDetailComponent implements OnInit {
  statementId = '';
  runId = '';
  run: ReconRunResponse | null = null;

  isLoading = true;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private reconciliationService: ReconciliationService
  ) {}

  ngOnInit(): void {
    const statementId = this.route.snapshot.paramMap.get('statementId');
    const runId = this.route.snapshot.paramMap.get('runId');

    if (!statementId || !runId) {
      this.errorMessage = 'Statement id or run id is missing.';
      this.isLoading = false;
      return;
    }

    this.statementId = statementId;
    this.runId = runId;
    this.loadRun();
  }

  loadRun(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.reconciliationService.getRun(this.statementId, this.runId).subscribe({
      next: run => {
        this.run = run;
        this.isLoading = false;
      },
      error: error => {
        console.log('Reconciliation run detail error:', error);
        this.errorMessage =
          error?.error?.message ??
          error?.message ??
          'Failed to load reconciliation result.';
        this.isLoading = false;
      },
    });
  }

  formatMoney(value: MoneyDto | null | undefined): string {
    if (!value) {
      return '—';
    }

    const amount =
      value.amount === null || value.amount === undefined ? '—' : Number(value.amount).toFixed(2);

    return value.currency ? `${amount} ${value.currency}` : amount;
  }

  hasDetails(details: Record<string, unknown> | null | undefined): boolean {
    return !!details && Object.keys(details).length > 0;
  }
}
